import React, { useState } from 'react';
import { WORKER_URL } from '../../utils/api';

export default function SubscribeForm({ source = 'blog', compact = false }) {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle'); // idle | loading | ok | error

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setStatus('loading');
    try {
      const res = await fetch(`${WORKER_URL}/api/blog/subscribe`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, source }),
      });
      setStatus(res.ok ? 'ok' : 'error');
    } catch {
      setStatus('error');
    }
  };

  if (status === 'ok') {
    return (
      <div style={{ textAlign: 'center', padding: compact ? '16px' : '24px', background: '#f0fdf4', borderRadius: 12, border: '1px solid #bbf7d0' }}>
        <div style={{ fontSize: compact ? 22 : 28, marginBottom: 6 }}>✅</div>
        <p style={{ color: '#15803d', fontWeight: 600, fontSize: compact ? 14 : 16, margin: 0 }}>
          Confirmado! Verifique seu email.
        </p>
      </div>
    );
  }

  if (compact) {
    return (
      <form onSubmit={handleSubmit} style={{ display: 'flex', gap: 8 }}>
        <input
          type="email" value={email} onChange={e => setEmail(e.target.value)}
          placeholder="seu@email.com" required
          style={{ flex: 1, padding: '10px 14px', border: '1px solid rgba(255,255,255,0.3)', borderRadius: 8, fontSize: 14, background: 'rgba(255,255,255,0.1)', color: '#fff', outline: 'none' }}
        />
        <button type="submit" disabled={status === 'loading'}
          style={{ padding: '10px 20px', background: '#FFD400', color: '#0A0F33', border: 'none', borderRadius: 8, fontWeight: 800, fontSize: 14, cursor: 'pointer', whiteSpace: 'nowrap' }}>
          {status === 'loading' ? '...' : 'Quero receber'}
        </button>
        {status === 'error' && <span style={{ fontSize: 12, color: '#fca5a5', alignSelf: 'center' }}>Erro, tente novamente.</span>}
      </form>
    );
  }

  return (
    <div style={{ background: '#1B2A7A', borderRadius: 16, padding: '36px', marginTop: 48, textAlign: 'center' }}>
      <p style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: 12, color: '#FFD400', letterSpacing: '0.1em', marginBottom: 12, textTransform: 'uppercase' }}>
        Newsletter gratuita
      </p>
      <h3 style={{ fontFamily: "'Archivo', sans-serif", fontWeight: 900, fontSize: 22, color: '#FAF8F3', margin: '0 0 10px', letterSpacing: '-0.02em' }}>
        Dicas semanais para vender mais no Mercado Livre
      </h3>
      <p style={{ color: 'rgba(250,248,243,0.7)', fontSize: 14, margin: '0 0 22px' }}>
        Sem spam. Cancele quando quiser.
      </p>
      <form onSubmit={handleSubmit} style={{ display: 'flex', gap: 10, maxWidth: 420, margin: '0 auto', flexWrap: 'wrap', justifyContent: 'center' }}>
        <input
          type="email" value={email} onChange={e => setEmail(e.target.value)}
          placeholder="seu@email.com" required
          style={{ flex: 1, minWidth: 200, padding: '12px 16px', border: '1px solid rgba(255,255,255,0.2)', borderRadius: 10, fontSize: 15, background: 'rgba(255,255,255,0.08)', color: '#fff', outline: 'none' }}
        />
        <button type="submit" disabled={status === 'loading'}
          style={{ padding: '12px 24px', background: '#FFD400', color: '#0A0F33', border: 'none', borderRadius: 10, fontFamily: "'Archivo', sans-serif", fontWeight: 800, fontSize: 15, cursor: status === 'loading' ? 'not-allowed' : 'pointer', opacity: status === 'loading' ? 0.7 : 1 }}>
          {status === 'loading' ? 'Enviando...' : 'Quero receber →'}
        </button>
      </form>
      {status === 'error' && <p style={{ color: '#fca5a5', fontSize: 13, marginTop: 10 }}>Algo deu errado. Tente novamente.</p>}
    </div>
  );
}
